import Link from 'next/link';
import { useRouter } from 'next/router';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { isChatReceiver } from '../../../../utils/chatUtils';
import { CHAT_ROUTE } from '../../../../utils/routes';
import {
  chatMakeSeen,
  getUsersAsync,
  resetUsers,
} from '../../../store/slices/common/chatSlice';
import ChatListItem from '../../Chat/ChatListItem';
import NoChats from '../../Chat/NoChats';
import ChatListItemsSkeleton from '../../SkeletonLoaders/ChatListItemsSkeleton';

export default function ChatMenuContent({ setShowChatComponent = () => {} }) {
  const lang = useSelector(({ common }) => common?.language);
  const router = useRouter();
  const { city } = router?.query;
  const dispatch = useDispatch();
  const users = useSelector(({ chat }) => chat?.users) || [];

  // const unreadNotifications = useSelector(
  //   ({ notifications }) => notifications?.unreadNotifications
  // );

  const loadingUsers = useSelector(({ chat }) => chat?.loadingUsers);

  // function readChatNotifications() {
  //   if (unreadNotifications && unreadNotifications.length > 0) {
  //     for (const item of unreadNotifications) {
  //       if (CHAT_NOTIFICATION_TYPES.includes(item?.notification_type)) {
  //         dispatch(
  //           makeReadNotificationsAsync({ id: item?.id, is_top: 1 })
  //         ).then((res) => {
  //           if (res?.payload?.id) {
  //             dispatch(getTopNotificationsAsync());
  //           }
  //         });
  //       }
  //     }
  //   }
  // }

  const loadChat = (friend) => {
    if (friend?.user_id) {
      if (!friend?.is_seen && isChatReceiver(friend?.receiver_profile_id))
        dispatch(chatMakeSeen({ id: friend?.chat_id }));
      router.push(
        CHAT_ROUTE({
          userId: friend?.user_id,
          profileId: friend?.profile_id,
          city,
        })
      );
    }
  };

  useEffect(() => {
    if (users === null || (Array.isArray(users) && users?.length === 0)) {
      dispatch(resetUsers());
      dispatch(getUsersAsync({ filter: 'all', take: 5 }));
    }
    // readChatNotifications();
    // dispatch(setUnreadChatExists(false));
  }, []);

  return (
    <div className='relative h-[590px] w-full md:w-[400px]'>
      <h3 className='border-b p-3 text-2xl font-bold'>{lang?.common?.chat}</h3>
      {!loadingUsers && users && Array.isArray(users) && users.length > 0
        ? users.slice(0, 5).map((user, index) => (
            <div
              key={index}
              onClick={() => loadChat(user)}
              className={`cursor-pointer bg-white hover:bg-gray-50`}
            >
              <ChatListItem data={user} />
            </div>
          ))
        : !loadingUsers &&
          Array.isArray(users) &&
          users.length == 0 && (
            <div className='flex h-[80%] items-center justify-center overflow-y-hidden'>
              <NoChats />
            </div>
          )}
      {loadingUsers && <ChatListItemsSkeleton />}
      {!loadingUsers && Array.isArray(users) && users?.length > 0 ? (
        <Link
          href={`${process.env.NEXT_PUBLIC_FRONTEND_URL}/chats?city=${city}`}
          className='absolute bottom-0 w-full pb-8 text-center text-sm font-semibold text-black'
        >
          <span
            onClick={() => {
              setShowChatComponent(false);
            }}
            className='rounded-[100px] border-2 border-black px-[34px] py-[9px]'
          >
            {lang?.common?.see_all_messages}
          </span>
        </Link>
      ) : null}
    </div>
  );
}
